export interface BaseQuestion {
  answerId: string
  question: string | null
  questionId: string
  answer?: string
}

export interface ConvenienceTestQuestion extends BaseQuestion {
  extraQuestions: null | BaseQuestion[]
  stage: CONVENIENCE_TEST_STAGES_ID
}

export interface BaseAnswer {
  answer: null | string
  answerId: string
  questionId: string
}

export interface ConvenienceTestAnswer extends BaseAnswer {
  stage: CONVENIENCE_TEST_STAGES_ID
  extraAnswer: string | null
  extraAnswers: null | Array<BaseQuestion | BaseAnswer>
}

export interface ConvenienceTestQuestionnaire {
  result: string
  testId: number
  questions: ConvenienceTestQuestion[]
  answers: ConvenienceTestAnswer[]
}
export type ConvenienceTestGroupedSelectedAnswers = Record<string, ConvenienceTestAnswer>

export type ConvenienceTestGroupedQuestions = Record<string, ConvenienceTestQuestion[]>
export interface Stage {
  stageTitle: string
  questions: ConvenienceTestGroupedQuestions
}

export interface CommonStageProps {
  stageQuestions: ConvenienceTestQuestion[]
  answers?: ConvenienceTestGroupedSelectedAnswers
  onExtraAnswerChange: (args: UpdateExtraAnswerPayload) => void
  onExtraAnswersChange: (args: UpdateExtraAnswersPayload) => void
  errors?: Record<string, { message?: string }[]>
}

export type AdaptedConvenienceTest = {
  result: string
  testId: number
  stage1: Stage
  stage2: Stage
  stage3: Stage
}
export enum ConvenienceTestStatus {
  VALID = 'VALID',
  EXPIRED = 'EXPIRED',
}

export interface ConvenienceTest {
  status: ConvenienceTestStatus
  completionDate: string
  expirationDate: string
}

export interface UpdateExtraAnswerPayload {
  stage: string
  questionId: string
  answerId: string
  value: string | null
}
export interface UpdateExtraAnswersPayload {
  stage: string
  questionId: string
  answerId: string
  value: BaseAnswer | null
}
export interface UpdateStage1AnswerPayload {
  questionId: string
  answerId: string
}
export const RELATED_STAGE_3_TO_2_QUESTIONS_IDS = {
  '4a': '3a',
  '4b': '3b',
} as const
export const RELATED_STAGE_2_TO_3_QUESTIONS_IDS = {
  '3a': '4a',
  '3b': '4b',
} as const

export enum CONVENIENCE_TEST_STAGES_ID {
  STAGE_1 = '1',
  STAGE_2 = '2',
  STAGE_3 = '3',
}
